import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { userLanaguageEvent, SupportedLanguage } from '../features/app/model';

interface LanguageRouteProps {
    children: React.ReactNode;
}

export const LanguageRoute: React.FC<LanguageRouteProps> = ({ children }) => {
    const { lang } = useParams<{ lang: string }>();
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const supportedLanguages = ['en', 'sv', 'es', 'fr', 'de', 'it', 'pt', 'ru', 'ja'];
        
        if (lang) {
            const normalizedLang = lang.toLowerCase();
            
            if (supportedLanguages.includes(normalizedLang)) {
                // Update language if it's different from current
                if (i18n.language !== normalizedLang) {
                    i18n.changeLanguage(normalizedLang);
                    // Convert to proper SupportedLanguage type
                    const langUpper = normalizedLang.toUpperCase() as SupportedLanguage;
                    userLanaguageEvent(langUpper);
                    localStorage.setItem('i18nextLng', normalizedLang);
                }
            } else {
                // Redirect to home if language is not supported
                navigate('/', { replace: true });
            }
        }
    }, [lang, i18n, navigate]);

    return <>{children}</>;
}; 